<template>
  <ExpandCard
    :key="item.name"
    :persistKey="`cmpstratexpand_${item.name}`"
    :canOpen="!skeleton"
    :hasCloseIcon="false"
    style="
      --radius-open: 4px;
      --min-height: 3.5rem;
      --content-padding: 0.25rem 0.75rem 0.75rem 0.75rem;
      --clr-back-content: var(--clr-black-2);
      --clr-back-title-hover: var(--clr-black-2);
      --title-padding: 0.25rem 0.75rem 1.25rem 0.75rem;
    "
  >
    <template #title>
      <div class="f-center w-100 clr-white">
        <div
          class="mr-auto"
          :class="{ 'clr-grey': skeleton }"
        >
          {{ title || $t(`browse.filter_rules.${item.name}`) }}
        </div>

        <div class="slfgrstracmp_chart">
          <div
            class="graph-horizontal graph-horizontal_full"
            style="height: 0.875rem"
          >
            <div
              v-for="(aa, idx) in item.solution"
              :key="`${aa.action.code}_${idx}`"
              class="graph-horizontal_item"
              :style="`width: ${
                aa.heroAction.total_frequency * 100
              }%; ${`background:${aa.action.hex}`}`"
            ></div>
          </div>
          <div
            class="graph-horizontal graph-horizontal_full"
            style="height: 0.875rem; flex-direction: row-reverse"
          >
            <div
              v-for="(aa, idx) in item.solution"
              :key="`${aa.action.code}_${idx}`"
              class="graph-horizontal_item"
              :style="`width: ${
                aa.opponentAction.total_frequency * 100
              }%; ${`background:${aa.action.hex}`}`"
            ></div>
          </div>
        </div>
      </div>
    </template>

    <CompareChartBox
      v-for="aa in item.solution"
      :key="aa.id"
      class="mt-2"
      :isCentered="true"
      :pLeft="aa.heroAction.total_frequency || 0"
      :pRight="aa.opponentAction.total_frequency || 0"
      :clrPrimary="aa.hex"
      :clrSecondary="aa.hex"
      :style="`--clr-back-winn:${aa.action.hex};`"
      style="
        --clr-back-lose: var(--clr-back-winn);
        --clr-equal-left: var(--clr-back-winn);
        --clr-equal-right: var(--clr-back-winn);
        --grid-gap: 1px;
        --weight: 500;
        --weight-legend: 500;
      "
    >
      <template #legend_left>
        <span class="rabb_score_chart_action-value">
          {{
            aa.heroAction.total_frequency
              ? numFixedUnit((aa.heroAction.total_frequency || 0) * 100, 'strategy') + '%'
              : ''
          }}
        </span>
      </template>
      <template #legend_center>
        <span class="rabb_score_chart_action-name">
          {{ aa.action.display_name || $t(`browse.${aa.action.group_display_name}`) }}
          <span
            class="pl-1"
            v-html="getBetHtml({ showBetsIn, a: aa.action })"
          ></span>
        </span>
      </template>
      <template #legend_right>
        <span class="rabb_score_chart_action-value">
          {{
            aa.opponentAction.total_frequency
              ? numFixedUnit((aa.opponentAction.total_frequency || 0) * 100, 'strategy') + '%'
              : ''
          }}
        </span>
      </template>
    </CompareChartBox>
  </ExpandCard>
</template>

<script>
import CompareChartBox from '@/components/Charts/CompareChartBox/CompareChartBox'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'SolfigrStrategyComparisonBox',
  components: {
    CompareChartBox,
    ExpandCard,
  },
  mixins: [format_mix],
  props: {
    item: Object,
    title: String,
    showBetsIn: String,
    skeleton: { type: Boolean, default: true },
  },
}
</script>
<style lang="scss" scoped>
.slfgrstracmp {
  &_chart {
    display: flex;
    gap: 1px;
    position: absolute;
    left: 0.75rem;
    border-radius: 4px;
    width: calc(100% - 1.5rem);
    overflow: hidden;
    z-index: 4;
    bottom: 0.5rem;
  }
}
</style>
